var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M62.31 139.64H15V18.97h47.31m35.52 120.67h47.31V18.97H97.83",
    style: {
      fill: "none",
      stroke: "#1d1d1b",
      strokeLinejoin: "round",
      strokeWidth: "1.98px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80.07,
    cy: 79.31,
    r: 41.97,
    style: {
      strokeLinecap: "round",
      fill: "none",
      stroke: "#1d1d1b",
      strokeLinejoin: "round",
      strokeWidth: "1.98px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.9 88.13a5.73 5.73 0 0 0-1.7-4.27 16.45 16.45 0 0 0-6-3.13q-5.31-1.67-7.44-4a8.34 8.34 0 0 1-2.14-5.93A8.46 8.46 0 0 1 73 64.62a9.66 9.66 0 0 1 6.39-2.71v-4.75h2.4v4.75a9 9 0 0 1 6.4 3.09 11.21 11.21 0 0 1 2.27 7.4h-2.8a8.56 8.56 0 0 0-1.92-5.87 6.58 6.58 0 0 0-5.22-2.17 7.31 7.31 0 0 0-5.21 1.75 6.13 6.13 0 0 0-1.87 4.67 5.7 5.7 0 0 0 1.72 4.42 16.81 16.81 0 0 0 5.84 3 25.6 25.6 0 0 1 6 2.68 8.55 8.55 0 0 1 2.8 3 8.84 8.84 0 0 1 .93 4.19 8.34 8.34 0 0 1-2.41 6.22A10.23 10.23 0 0 1 81.69 97v4.47h-2.37V97A10.69 10.69 0 0 1 72 94a10.06 10.06 0 0 1-2.59-7.3h2.82a7.67 7.67 0 0 0 2.14 5.75 8.2 8.2 0 0 0 6 2.08 8.05 8.05 0 0 0 5.44-1.79 5.82 5.82 0 0 0 2.09-4.61Z",
    style: {
      fill: "#1d1d1b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.7f70661b.svg";
export { ForwardRef as ReactComponent };